module.exports = __webpack_public_path__ + "img/chat_3.be7fed09.png";